import { ChatMessage } from '@stores';

export type CombinedChatMessage = { content: string[] } & ChatMessage;

export function combineMessages(messages: ChatMessage[]): CombinedChatMessage[] {
  return messages.reduce<CombinedChatMessage[]>((acc, message) => {
    const lastMessage = acc[acc.length - 1];

    if (
      lastMessage
      && lastMessage.author
      && message.author
      && lastMessage.author.id === message.author.id
    ) {
      lastMessage.createdAt = message.createdAt;
      lastMessage.content.push(message.content);
    } else {
      const { content, ...rest } = message;

      acc.push({ 
        ...rest, 
        content: [content] 
      } as CombinedChatMessage);
    }

    return acc;
  }, []);
};
